<template>
  <PanelTemplate ref="panel">
    <TabsTemplate ref="tabs" :tabs="autoPanelTabs" @onCloseButtonClicked="hide()"></TabsTemplate>
  </PanelTemplate>
</template>

<script>
import { markRaw } from 'vue'
import { mapState, mapGetters } from 'vuex'

import PanelTemplate from '@/components-v2/presentation-editor/right-panel-container/PanelTemplate.vue'
import TabsTemplate from '@/components/UI/TabsTemplate.vue'
import AIImprovePanel from '@/components-v2/presentation-editor/side-right/right-nav/AIImprovePanel.vue'
import AIController from '@/components-v2/presentation-editor/side-right/right-nav/AIController.vue'

export default {
  components: {
    PanelTemplate,
    TabsTemplate,
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),

    ...mapGetters('slideType', ['isContentSlide']),

    isPanelDisabled() {
      return !this.isContentSlide
    },

    autoPanelTabs() {
      return [
        {
          name: 'Improve Writing',
          component: markRaw(AIImprovePanel),
        },
        {
          name: 'Create',
          component: markRaw(AIController),
        }]
    },

    hasSlideId() {
      return this.slideActive && this.slideActive.id
    },

    defaultTabIndex() {
      if (!this.isContentSlide || !this.hasSlideId) return 1
      return 0
    },
  },

  methods: {
    show(tabIndex) {
      const currentTabIndex = tabIndex || this.defaultTabIndex
      this.$refs.panel.show()
      this.selectTab(currentTabIndex)
    },

    hide() {
      this.$refs.panel.hide()
    },

    toggle(visibility, tabIndex) {
      this.$refs.panel.toggle(visibility)
      this.selectTab(tabIndex)
    },

    panelVisible() {
      return this.$refs.panel.getVisibility()
    },

    selectTab(index) {
      if (this.$refs.tabs) {
        this.$refs.tabs.selectTab(index)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/variable.scss";

.ai-improve-panel {
  @apply relative h-full;
}
.ai-improve-panel__content {
  @apply overflow-y-auto pt-6 relative;
  padding-bottom: $right-panel-header-height;
  height: calc(100% - $right-panel-header-height);
}
.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
  z-index: 9;
}
</style>
